import Vue from 'vue'
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from './App.vue';

// Replace "foo" with the name of the resource type
import user from './store/modules/user/';
import organization from './store/modules/organization/';
import cookie from './store/modules/cookie/';
import cookiepreset from './store/modules/cookiepreset/';
import textblock from './store/modules/textblock/';
import channel from './store/modules/channel/';
import log from './store/modules/log/';

import userRoutes from './routes/user';
import organizationRoutes from './routes/organization';
import textblockRoutes from './routes/textblock';
import cookieRoutes from './routes/cookie';
import cookiepresetRoutes from './routes/cookiepreset';
import channelRoutes from './routes/channel';
import logRoutes from './routes/log';

import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue';






import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';



Vue.use(VueResource);

Vue.use(Vuex);

Vue.use(BootstrapVue);


import { API_HOST, API_PATH } from './config/_entrypoint';


import Login from './components/pages/Login.vue';




Vue.use(VueRouter);



const store = new Vuex.Store({
    modules: {
        user,
        organization,
        textblock,
        cookie,
        cookiepreset,
        channel,
        log
    }
});

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {auth: false}
        },
        ...userRoutes,
        ...organizationRoutes,
        ...cookieRoutes,
        ...cookiepresetRoutes,
        ...textblockRoutes,
        ...channelRoutes,
        ...logRoutes
    ]

});



window.vue=new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js